import ngFileSaver from 'angular-file-saver';

import { DataServiceModule } from 'services/data/data.service';
import { AuthTokenServiceModule } from 'services/auth/authToken.service';
import { AppSettingsModule } from 'services/settings.provider';
import { SearchServiceModule } from 'services/data/search.service';
import { OnboardingServiceModule } from 'services/data/onboarding.service';

export const CustomerServiceModule = angular
    .module('app.pages.customers.customersService', [
        ngFileSaver,
        DataServiceModule,
        AuthTokenServiceModule,
        AppSettingsModule,
        SearchServiceModule,
        OnboardingServiceModule
    ]).service('customerService', (
        $q,
        $filter,
        $window,
        dataService,
        authTokenService,
        searchService,
        settings,
        FileSaver,
        onboardingService
    ) => {
        return {
            save,
            saveAll,
            create,
            removeCustomer,
            bulkUpload,
            copyCustomer,
            copyCustomers,
            getCustomer,
            getCustomers,
            getMetrics,
            getCustomerCount,
            getCustomersSorted,
            getBulkUploadStatus,
            exportCustomers,
            getShippingAddresses,
            getShippingAddress,
            addShippingAddress,
            updateShippingAddress,
            deleteShippingAddress,
            getAvalaraEntityUseCodes
        };

        function save(customer) {
            return dataService.save(settings.api.customers, customer.id, customer);
        }

        function saveAll(customers) {
            var promises = [];

            for (let i = 0; i < customers.length; i += 1) {
                var customer = angular.copy(customers[i]);
                promises.push(dataService.save(settings.api.customers, customer.id, customer));
            }

            return $q.all(promises);
        }

        function create(customer) {
            return dataService.create(settings.api.customers, customer).then((newCustomer) => {
                let taskId = 'organize.addCustomer';
                let sessionKey = 'customersService:firstCustomerCreated';
                $window.sessionStorage.setItem('customersService:customerCreated', true);
                return onboardingService.completeInitialTask(taskId, sessionKey).then(() => {
                    return newCustomer;
                });
            });
        }

        function removeCustomer(customer) {
            return dataService.remove(settings.api.customers, customer.id);
        }

        function bulkUpload(csvObj) {
            return dataService.saveAll(settings.api.customerBulkUpload, csvObj);
        }

        function getBulkUploadStatus() {
            return dataService.get(settings.api.customerBulkUploadStatus);
        }

        function copyCustomer(item, nameLength) {
            nameLength = nameLength || 35;
            var strLength = nameLength - 7;
            var copyItem = angular.copy(item);

            copyItem.name = `${item.name.substring(0, strLength)} - COPY`;
            return dataService.create(settings.api.customers, copyItem);
        }

        function copyCustomers(items, nameLength) {
            var promises = [];
            Object.keys(items).forEach((i) => {
                var copyItem = angular.copy(items[i]);
                promises.push(dataService.copy(settings.api.customers, copyItem, nameLength));
            });

            return $q.all(promises);
        }

        function getCustomer(id) {
            return dataService.get(settings.api.customers, id);
        }

        function getCustomers(page, count, sortBy, sortDirection, options) {
            options = options || {};
            page = page || 1;
            count = count || 50;

            options.pageSize = count;
            options.startIndex = (page - 1) * count;

            if (sortBy && sortDirection) {
                options.sortBy = sortBy;
                options.sortDirection = sortDirection;
            }

            return dataService.getAll(settings.api.customers, options);
        }

        function getMetrics() {
            let newCustomerCountPromise = getCustomerCountLast30Days();
            let totalCustomerCountPromise = getCustomerCount();

            return $q.all([
                newCustomerCountPromise,
                totalCustomerCountPromise
            ]).then((response) => {
                return {
                    newCustomerCount: response[0],
                    totalCustomerCount: response[1]
                };
            });
        }

        function getCustomersSorted(page = 1, hitsPerPage = 50, sort = 'customers_lastname_asc') {
            var searchOptions = {
                page: page - 1,
                hitsPerPage
            };
            return searchService.getAll(sort, '', searchOptions)
                .then((data) => {
                    return {
                        items: data.hits,
                        totalCount: data.nbHits
                    };
                });
        }

        function getCustomerCountLast30Days() {
            return dataService.getAll(settings.api.customersCount, {})
                .then(response => response);
        }

        function getCustomerCount() {
            return dataService.getAll(settings.api.customers, {})
                .then(response => response.totalCount);
        }

        function exportCustomers() {
            return dataService.get(`${settings.api.customers}/export`)
                .then(response => saveStringToCsv(response.csvData, 'VolusionCustomerExport.csv'));
        }

        function saveStringToCsv(string, fileName) {
            const blob = new Blob([string], { type: 'text/csv' });
            FileSaver.saveAs(blob, fileName);
            return blob;
        }

        function getShippingAddresses(customerId) {
            return dataService.getAll(`${settings.api.customers}/${customerId}/shippingaddress`);
        }

        function getShippingAddress(customerId, addressId) {
            return dataService.get(`${settings.api.customers}/${customerId}/shippingaddress/${addressId}`);
        }

        function addShippingAddress(customerId, address) {
            return dataService.create(`${settings.api.customers}/${customerId}/shippingaddress`, address);
        }

        function updateShippingAddress(customerId, address) {
            return dataService.save(
                `${settings.api.customers}/${customerId}/shippingaddress`,
                address.id,
                address
            );
        }

        function deleteShippingAddress(customerId, addressId) {
            return dataService.remove(`${settings.api.customers}/${customerId}/shippingaddress/${addressId}`);
        }

        function getAvalaraEntityUseCodes() {
            return dataService.get(settings.api.avalaraEntityUseCodes);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/customers/customers.service.js